<div class="modal-popup">
  <form class="discard-popup-container" [formGroup]="discardForm">
    <p class="title">Atenção</p>
    <p class="description">Ao descartar uma fac você não poderá mais acessá-la</p>

    <div class="dropdown-box">
      <p class="dropdown-title">Razão do descarte</p>
      <app-dropdown-button [label]="discardForm.get('reason').value ? discardForm.get('reason').value : 'Selecione'" [(isOpen)]="openReason" (valueChange)="openReason = $event">
        <ul class="dropdown-text-list" (click)="openReason = false">
          <li class="li-label" *ngFor="let item of dropDownOptions" (click)="setReason(item)">
            <p>{{item}}</p>
          </li>
        </ul>
      </app-dropdown-button>
    </div>

    <div class="input-box">
      <p class="input-title">Observações</p>
      <textarea formControlName="observation" class="email-input"></textarea>
    </div>

    <div class="btn-container">
      <lib-button-tertiary (click)="closeModal.emit(true)">Cancelar</lib-button-tertiary>
      <lib-button-primary (click)="discardForm.valid ? discartEvent.emit(discardForm.getRawValue()) : null" [isDisabled]="discardForm.invalid">Descartar</lib-button-primary>
    </div>
  </form>
</div>